//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FCImage from '~/components/FCImage.vue';

export default {
  name: 'Workouts4_Time',
  components: {
    FCImage,
  },
  props: {
    imgUrl: {
      type: String,
      default: 'v4/fc-workouts-man-sitting-clockoverlay-002.jpg',
    },
    reverse: Boolean,
    column: Boolean,
  },
};
